export function isNil(value: unknown): value is null | undefined {
  return value === undefined || value === null;
}

export function isNotNil<T>(value: T): value is NonNullable<T> {
  return !isNil(value);
}
